import React, { useState, useEffect } from "react";

import Breadcrumbs from "../../../components/Breadcrumbs";

import { useTranslation } from "react-i18next";

import AuthUser from "../../../components/AuthUser";

import Spinner from "../../../components/Spinner";
import TipoDocumentoFilter from "../Administration/employees/TipoDocumentoFilter";
import TipoDocumentoTable from "../Administration/employees/TipoDocumentoTable";
import TipoDocumentoModal from "../../../components/Administration/employees/TipoDocumentoModal";

const TipoDocumento = () => {

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user_permissoes, verificarPermissao, getMissao } = AuthUser();
  const [tipo_documentos, settipo_documentos] = useState([]);  

  const [filteredtipo_documentos, setfilteredtipo_documentos] = useState([]);

  const { t } = useTranslation();

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  // Callback function to receive filtered users from UserFilter
  const handleFilterSubmit = (filteredtipo_documentos) => {     
    setfilteredtipo_documentos(filteredtipo_documentos?.filter((tipo_documento) => tipo_documento?.tipo == 1)); 
  };


  const handleSubmissionSuccess = (tipo_documentos) => {
    // Refresh acessos state or trigger any necessary actions
    settipo_documentos(tipo_documentos);    
  };

  const gettipo_documentos = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get('/tipo-documento/'+getMissao()?.id);

      settipo_documentos(res.data.tipo_documentos);

      setLoading(false);

    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  }; 
 

  useEffect(() => {

    const fetchData = async () => {
      try {
        // Chama a função assíncrona getUtilizador()
        await gettipo_documentos();

      } catch (error) {
        console.error('Erro ao obter tipo_documentos:', error);
      }
    };

    // Chama a função fetchData() para iniciar o processo
    fetchData();
  }, []);

  if (verificarPermissao('CARGO', 'ver')) 
  if (loading) return (<><Spinner></Spinner></>); else return (
    <>
      (
      <>
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle={t('Tipo Documento')}
          title="Dashboard"
          subtitle={t('Modelos documentos anexados colaboradores')}
          modal="#add_tipo_documento_modal"
          name={t('Add Tipo Documento')}
        />
        <TipoDocumentoFilter onFilterSubmit={handleFilterSubmit} />
        <TipoDocumentoTable tipo_documentos={filteredtipo_documentos.length > 0 ? filteredtipo_documentos : tipo_documentos} tipo={1} />
        <TipoDocumentoModal onSubmissionSuccess={handleSubmissionSuccess} tipo={1} />
      </div>
    </div> </>
        ); </>
    );
  else
    return (<>
      <div className="page-wrapper cardhead">
        <div className="content ">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">SEM PERMISSÃO</h3>

              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">

              <div className="card">
                <div className="card-header">
                  <h4 className="card-title"><i className="fa fa-times-circle text-danger"></i>&nbsp; OPERAÇÃO NÃO AUTORIZADA</h4>
                </div>
                <div className="card-body">
                  <p>
                    Esta operação não é autorizada para o seu nivel de acesso ao sistema, por favor contacte o administrador do sistema.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>)
};


export default TipoDocumento;
